export const hostnames = {
  local: 'http://app.kuzzle.test:8081/',
  uat: 'https://app.uat.v2.myomniscient.com/',
  staging: 'https://app.staging.v2.myomniscient.com/',
  production: 'https://app.v2.myomniscient.com/',
}

export const dateRangeType = {
  BEFORE_DATE: 'before',
  AFTER_DATE: 'after',
  EQUAL_DATE: 'equal',
  RANGE_DATE: 'range',
}

export const availableFeaturesFlags = [
  'liveSite',
  'homepage',
  'tagInTagOut',
  'counters',
]

export const alertTypes = {
  BATTERY: 'battery',
  COUNTER: 'counters',
}

export const actions = {
  CREATE: 'create',
  EDIT: 'edit',
}

export const defaultAssetListColumns = [
  {
    name: 'reference',
    default: true,
    required: true,
    path: 'common.reference',
    location: 'common',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 1,
  },
  {
    name: 'designation',
    default: true,
    required: true,
    path: 'common.designation',
    location: 'common',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 2,
  },
  {
    name: 'family',
    default: true,
    path: 'common.family',
    location: 'common',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 3,
  },
  {
    name: 'subFamily',
    default: true,
    path: 'common.subFamily',
    location: 'common',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 4,
  },
  {
    name: 'manufacturerId',
    default: true,
    path: 'tag.manufacturerId',
    location: 'tag',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 5,
  },
  {
    name: 'area',
    default: true,
    path: 'tag.location.area',
    location: 'tag',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 6,
  },
  {
    name: 'floor',
    default: true,
    path: 'tag.location.floor',
    location: 'tag',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 7,
  },
  {
    name: 'lastTagUpdate',
    default: true,
    path: 'tag.lastTagUpdate',
    location: 'tag',
    type: 'date',
    family: '',
    subFamily: '',
    sortable: true,
    order: 8,
  },
  {
    name: 'lastPositionUpdate',
    default: false,
    translate: true,
    path: 'tag.location.lastPositionUpdate',
    location: 'tag',
    type: 'date',
    family: '',
    subFamily: '',
    sortable: true,
    order: 9,
  },
  {
    name: 'locationCity',
    default: false,
    translate: true,
    path: 'tag.location.city',
    location: 'tag',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 10,
  },
  {
    name: 'locationLat',
    default: false,
    translate: true,
    path: 'tag.location.position.lat',
    location: 'tag',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 11,
  },
  {
    name: 'locationLon',
    default: false,
    translate: true,
    path: 'tag.location.position.lon',
    location: 'tag',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 12,
  },
]

export const elasticQueryOperands = {
  contains: 'Contains',
  not_contains: 'Not Contains',
  equal: 'Equal',
  not_equal: 'Not equal',
  range: 'Range',
  exists: 'Exists',
  not_exists: 'Not exists',
}

export const defaultRegulationDates = [
  {
    name: 'reference',
    default: true, // toggle translation ie.'Référence' vs 'reference'
    required: false,
    checked: true,
    path: 'common.reference',
    location: 'common',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 1,
  },
  {
    name: 'designation',
    default: true,
    required: true,
    checked: true,
    path: 'common.designation',
    location: 'common',
    type: '',
    family: '',
    subFamily: '',
    sortable: true,
    order: 2,
  },
  {
    name: 'family',
    default: true,
    checked: false,
    path: 'common.family',
    location: 'common',
    type: '',
    family: '',
    subFamily: '',
    sortable: false,
    order: 3,
  },
  {
    name: 'subFamily',
    default: true,
    checked: false,
    path: 'common.subFamily',
    location: 'common',
    type: '',
    family: '',
    subFamily: '',
    sortable: false,
    order: 4,
  },
  {
    name: 'lastCity',
    default: true,
    checked: true,
    path: 'tag.location.city',
    location: 'tag',
    type: '',
    family: '',
    subFamily: '',
    sortable: false,
    order: 9999,
  },
]

export const sessionConfig = {
  SCREEN_EXPIRE_TIME: '30d',
}

export const specificRoles = {
  screen: 'screen',
  admin: 'admin',
}

export const configDocuments = {
  multiTenancyConfig: 'multi-tenancy-config',
}

export const collections = {
  ALERT: 'alerts',
  ASSET_HISTORY: 'asset-history',
  ASSET_LOCATION: 'asset-locations',
  ASSETS: 'assets',
  CONFIG: 'config',
  COUNTERS: 'counters',
  CUSTOMERS: 'customers',
  FORMS: 'forms',
  QR_CODE: 'qr-code',
  REFERENCES: 'references',
  REPORTS: 'reports',
  SITES: 'sites',
  TAG_HISTORY: 'tag-history',
  TAGS: 'tags',
}

export const allDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export const fileState = {
  STATUS_INITIAL: 0,
  STATUS_HOVERING: 1,
  STATUS_SAVING: 2,
  STATUS_SUCCESS: 3,
  STATUS_FAILED: 4,
  STATUS_PREVIEW: 5,
}

export const ATTRIBUTE_TYPES = ['string', 'date', 'list']

export const ATTRIBUTE_LOCATIONS = ['specific', 'metadata']

export const STEP = {
  FAMILY: 'FAMILY',
  ATTRIBUTE: 'ATTRIBUTE',
  CATALOG: 'CATALOG',
  DUPLICATE: 'DUPLICATE',
}

export const shape_types = {
  POLYGON: 'polygon',
  CIRCLE: 'circle',
}

export const customer_kinds = {
  WORKSITE: 'worksite',
  RENTER: 'renter',
  UNKNOWN: 'unknown',
}

export const site_types = {
  WORKSITE: 'chantier',
  AGENCY: 'agence',
}

export const TAG_TYPES = {
  GATEWAY: 'gateway',
  ANCHOR: 'anchor',
  TAG: 'tag',
}

export const TAG_STATUS = {
  OFFLINE: 'offline',
  UNCERTAIN: 'uncertain',
  ONLINE: 'online',
}

export const category = {
  PERSONNAL: 'personnal',
  MATERIAL: 'material',
}

export const environments = {
  local: 'local',
  staging: 'staging',
  production: 'production',
  uat: 'uat',
}

export const time_values = {
  minutes_per_hour: 60,
  hours_per_day: 24,
  seconds_per_minute: 60,
  miliseconds_per_second: 1000,
}

export const ROLE_LIST = ['admin', 'worker', 'preperer']

export const KUZZLE_PROFILES_PREFIX = 'kuzzleprofile-'

export const USER_SYNC_STATE = {
  DOES_NOT_EXIST: 'DOES_NOT_EXIST',
  UNSYNCED_CAN_DELETE: 'UNSYNCED_CAN_DELETE',
  UNSYNCED_CANNOT_DELETE: 'UNSYNCED_CANNOT_DELETE',
  DOES_NOT_EXISTS_CAN_DELETE: 'DOES_NOT_EXISTS_CAN_DELETE',
  DOES_NOT_EXISTS_CANNOT_DELETE: 'DOES_NOT_EXISTS_CANNOT_DELETE',
  SYNC: 'SYNC',
}

export const MAP_DRAWING_KIND = {
  CIRCLE: 'circle',
  DRAWING: 'drawing',
  FEATURE: 'feature',
  MARKER: 'marker',
  UNKNOWN: 'unknown',
}

export const offices = {
  FRONT_OFFICE: 'om-frontoffice',
  BACK_OFFICE: 'om-backoffice',
}
